module.exports = __webpack_public_path__ + "img/PL08483.bd248612.png";